import React, {useEffect, useState} from 'react'
import Select from "react-select";
import * as Yup from "yup";
import {Row, Col, FormGroup, Spinner, Form, Input, Collapse} from "reactstrap";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";


// components
import {ButtonCancel, ButtonSubmit} from "../../buttons/buttonsActions";

// actions
import { add } from "../../../redux/actions/todoFluye/wishlistActions";

// provider
import { restaurantProvider } from "../../../providers/ayb/restaurantProvider";

// labels
import {
    LB_COMMENTS, LB_DATE,
    LB_HOUR, LB_PEOPLE, LB_REMINDER,
    LB_WHAT_ALLERGIES, REQUIRED
} from "../../i18n/i18n";

// utils
import {formatStringDate} from "../../../util/DateTools";
import {restaurantPaxRestriction, wishlistTypes} from "../../../util/WishlistUtils";
import RestaurantPaxDetails from "../components/RestaurantPaxDetails";
import PaxDetailsIndicator from "../components/PaxDetailsIndicator";
import Switch from "react-bootstrap-switch";

const RestaurantFormComponent = props => {
    const fbDataBase = props.mainState?.app?.fbDataBase?.id
    const udn =  JSON.parse( localStorage.getItem('selectedUdn') )

    const { domainObject } = props.formState
    const { wishlist, handleCancel, handleToggle  } = props

    const [ editMode ] = useState(domainObject != null)

    const [ restaurants, setRestaurants ] = useState([])
    const [ restaurant, setRestaurant ] = useState( null )
    const [ restaurantError, setRestaurantError ] = useState( false )
    const [ loadingRestaurant, setLoadingRestaurant ] = useState(true)
    const [ loadedDefaultRestaurant, setLoadedDefaultRestaurant ] = useState(false)

    const [ restaurantInfo, setRestaurantInfo ] = useState( [] )
    const [ selectedRestaurantInfo, setSelectedRestaurantInfo ] = useState( null )

    const [pax, setPax] = useState(domainObject?.pax || 0)
    const [paxError, setPaxError] = useState(domainObject?.pax < 0)
    const [showPeopleSection, setShowPeopleSection] = useState( domainObject?.pax > 0)

    const [ paxDetails, setPaxDetails ] = useState([])
    const [ paxDetailsIndicator, setPaxDetailsIndicator ] = useState([])
    const [ showAllergicSection, setShowAllergicSection ] = useState(domainObject?.allergic > 0)

    const [ reminder, setReminder ] = useState( domainObject?.reminder || false )





    // load restaurants
    useEffect(() => {
        const requestData = {
            code : 'rest',
            udn : { id : udn?.id }
        };

        setLoadingRestaurant(true)

        restaurantProvider.getOptions(requestData)
            .then( result => {
                const [rest, info] = result

                setRestaurants(rest)
                setRestaurantInfo(info)
            })
            .finally( ()=> setLoadingRestaurant(false) )
    },[])


    // load restaurant default
    useEffect(() => {
        if(!domainObject)
            return

        if(!loadedDefaultRestaurant && restaurants.length >0){
            const selectedRestaurant = restaurants.find(i => i.id === domainObject?.place?.id)
            setRestaurant(selectedRestaurant)
            setLoadedDefaultRestaurant(true)
        }
    } ,[ restaurants ])


    // load restaurant info
    useEffect( () => {
        const selectedRestaurant = restaurantInfo.find(i => i.id === restaurant?.id)
        setSelectedRestaurantInfo( selectedRestaurant )
    },[restaurant])






    const validationSchema = Yup.object().shape({
        date: Yup.string().required( REQUIRED ),
        hour: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues:{
            date: domainObject ? formatStringDate(domainObject?.date) : null,
            hour: domainObject?.hour,
            comments: domainObject?.comments,
        }
    });


    const onSubmit = (data, _) => {
        if(!restaurant){
            setRestaurantError(true)
            return
        }

        if(paxError)
            return

        let dataRequest = {
            fbDataBase,
            item: {
                ... data,
                type: wishlistTypes.restaurant.description,
                from:'wishlist',
                reminder,
                wishlist: { id: wishlist?.id },
                place: { id: restaurant?.id }
            }
        }

        if(domainObject)
            dataRequest.item.id = domainObject?.id

        if(!showAllergicSection)
            dataRequest.item.allergies = ''

        dataRequest.item.pax = pax
        dataRequest.item.paxDetails = paxDetails

        props.add( dataRequest, handleToggle )
    }

    const onPaxChange = e => {
        const value = parseInt(e?.target?.value || '0')

        setPax(value)
        setPaxError(value <= 0)
        setShowPeopleSection(value > 0)
    }


    const onPaxesChange = paxes => {
        if(!paxes || paxes.length <= 0)
            return

        let formedPax = []

        paxes.forEach( ({id, value, code}) => {
            if(code === restaurantPaxRestriction?.allergic.description)
                setShowAllergicSection( value > 0 )

            formedPax.push({
                typeRestriction:{ id },
                value
            })
        })

        setPaxDetails( formedPax )
        setPaxDetailsIndicator( paxes )
    }



    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className={'mb-1em'}>
            <Col className={'wl-modal-title-item'}>
                <img
                    src={require(`../../../assets/images/wishlist/${props?.selectedOption?.icon}`)}
                    alt={props?.selectedOption?.title}
                    width={36}
                    height={36}
                /> &nbsp; { props?.selectedOption?.title }
            </Col>
            <Col>
                <FormGroup>
                    {
                        loadingRestaurant ?  <> <Spinner animation="border" /> </> : <Select
                            options={ restaurants }
                            value={ restaurant }
                            isClearable={ true }
                            onChange={ val => setRestaurant(val) }
                            isDisabled={ editMode }
                            styles={{ }}
                        />
                    }
                    { restaurantError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                { selectedRestaurantInfo?.info}
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-calendar' } aria-hidden='true' /> &nbsp;{ LB_DATE }
                    </label>
                    <Input
                        name='date'
                        type='date'
                        /*min={ getDateToFormField(wishlist?.checkIn) }
                        max={ getDateToFormField(wishlist?.checkOut) }*/
                        innerRef={register}
                    />
                    { errors?.date && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.date?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <label>
                    <i className={ 'fa fa-clock' } aria-hidden='true' /> &nbsp;{ LB_HOUR }
                </label>
                <FormGroup>
                    <Input
                        name='hour'
                        type="time"
                        innerRef={register}
                    />
                    { errors?.hour && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.hour?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <label>
                    <i className={ 'fa fa-users' } aria-hidden='true' /> &nbsp;{ LB_PEOPLE }
                </label>
                <FormGroup>
                    <Input
                        name='pax'
                        type="number"
                        min={1}
                        value={pax}
                        onChange={ onPaxChange }
                    />
                    { paxError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Collapse isOpen={showPeopleSection}>
            <RestaurantPaxDetails
                maxSize={ pax }
                setExternalData={ onPaxesChange }
            />

            <Collapse isOpen={showAllergicSection}>
                <Row className={'mb-1em'}>
                    <Col>
                        <label>{ LB_WHAT_ALLERGIES }</label>
                        <FormGroup>
                            <Input
                                name='allergies'
                                type="textarea"
                                innerRef={register}
                            />
                            { errors?.allergies && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.allergies?.message}</div>}
                        </FormGroup>
                    </Col>
                </Row>
            </Collapse>

            <PaxDetailsIndicator paxDetails={paxDetailsIndicator} />
        </Collapse>


        <Row>
            <Col sm={3}>
                <FormGroup>
                    <label>{ LB_REMINDER }</label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ reminder }
                        onChange={ () => setReminder(!reminder) }
                    />
                </FormGroup>
            </Col>
        </Row>


        <Row className={'mb-1em'}>
            <Col>
                <label>{ LB_COMMENTS }</label>
                <FormGroup>
                    <Input
                        name='comments'
                        type="textarea"
                        innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col className="d-flex justify-content-center">
                <div>
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ ()=> handleCancel() }/>
                </div>
            </Col>
        </Row>
    </Form>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})

const mapActionsToProps = ({
    add
})

export default connect(mapStateToProps, mapActionsToProps)(RestaurantFormComponent)
